import { useEventListener } from "@web-monorepo/hooks";
import { logClick } from "@web-monorepo/product-events/clickLogging";

function logMarketplaceClick(event: MouseEvent) {
  logClick(event, "marketplace", { anchorHref: "omit" });
}

export default function MarketplaceAutomaticClickLogger() {
  useEventListener("click", logMarketplaceClick, document.body, { capture: true });

  return null;
}
